module.exports = __webpack_public_path__ + "img/stakewise-red.b061391f.svg";